import React from "react";
//#region types
import { RatingBinaryProps } from "models/propTypes/commonPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import StyledButton from "../buttons/styledButton";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const RatingBinary: React.FC<RatingBinaryProps> = (props) => {
  const { ratingTitle, ratingPositiveText, ratingNegativeText, ratingPositiveIcon, ratingNegativeIcon, onRatingClick } =
    props;

  return (
    <Grid container direction="row" alignItems="center" className={cssExports.ratingElement} gap={1} flexWrap="nowrap">
      <Grid item xs className={cssExports.messageTitle}>
        {ratingTitle ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.RatingButtonTitle)}
      </Grid>
      <Grid
        item
        container
        xs="auto"
        justifyContent="center"
        className={cssExports.ratingButton}
        columnGap={1}
        flexWrap="nowrap"
      >
        <StyledButton
          secondary
          className={cssExports.ratingButtonPositive}
          onClick={onRatingClick?.bind(null, true)}
          size={"sm"}
          startIcon={ratingPositiveIcon ?? <Icon icon={IconDefinitionConstants.WThumbsUp} />}
        >
          {ratingPositiveText ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Yes)}
        </StyledButton>
        <StyledButton
          secondary
          className={cssExports.ratingButtonNegative}
          onClick={onRatingClick?.bind(null, false)}
          size={"sm"}
          startIcon={ratingNegativeIcon ?? <Icon icon={IconDefinitionConstants.WThumbsDown} />}
        >
          {ratingNegativeText ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.No)}
        </StyledButton>
      </Grid>
    </Grid>
  );
};

export default RatingBinary;
